module.exports = __webpack_public_path__ + "img/detail_close@2x.0cb4a2ef.png";